export const trait_impl_file = '/RustCode/trait_impl.rs';
export const impl_file = '/RustCode/impl.rs';
export const impl_with_generic_file = '/RustCode/impl_with_generic.rs';
export const trait_impl_with_generic_file = '/RustCode/trait_impl_with_generic.rs';
export const test_file = '/RustCode/tests.rs';
export const derive_file = '/RustCode/derive.rs';
export const new_type_file = '/RustCode/new_type.rs';
export const enum_file = '/RustCode/enum.rs'
export const if_let_file = '/RustCode/if_let.rs'